export const MIN_WIDTH = 30;
export const MIN_HEIGHT = 30;
export const HANDLE_SIZE = 10;

export const HANDLE_CONFIGS = [
  { key: "n", cursor: "ns-resize", className: "dr-handle-n" },
  { key: "s", cursor: "ns-resize", className: "dr-handle-s" },
  { key: "w", cursor: "ew-resize", className: "dr-handle-w" },
  { key: "e", cursor: "ew-resize", className: "dr-handle-e" },
  { key: "nw", cursor: "nwse-resize", className: "dr-handle-nw" },
  { key: "ne", cursor: "nesw-resize", className: "dr-handle-ne" },
  { key: "sw", cursor: "nesw-resize", className: "dr-handle-sw" },
  { key: "se", cursor: "nwse-resize", className: "dr-handle-se" },
];

export const clampRect = (rect) => {
  const width = Math.max(MIN_WIDTH, rect.width);
  const height = Math.max(MIN_HEIGHT, rect.height);

  return {
    x: rect.x,
    y: rect.y,
    width,
    height,
  };
};

export const applyResize = (direction, startRect, dx, dy) => {
  let { x, y, width, height } = startRect;

  if (direction.includes("e")) width = startRect.width + dx;
  if (direction.includes("s")) height = startRect.height + dy;

  if (direction.includes("w")) {
    width = startRect.width - dx;
    x = startRect.x + dx;
  }

  if (direction.includes("n")) {
    height = startRect.height - dy;
    y = startRect.y + dy;
  }

  if (width < MIN_WIDTH) {
    if (direction.includes("w")) {
      x = startRect.x + (startRect.width - MIN_WIDTH);
    }
    width = MIN_WIDTH;
  }

  if (height < MIN_HEIGHT) {
    if (direction.includes("n")) {
      y = startRect.y + (startRect.height - MIN_HEIGHT);
    }
    height = MIN_HEIGHT;
  }

  return { x, y, width, height };
};

export const getLiveTagByName = (latestTags, tagName) => {
  if (!tagName) return null;
  return (latestTags || []).find((tag) => tag.tag_name === tagName) || null;
};

export const getLiveTagValueByName = (latestTags, tagName) => {
  const liveTag = getLiveTagByName(latestTags, tagName);
  if (!liveTag) return "";

  if (
    liveTag.last_value === null ||
    liveTag.last_value === undefined ||
    liveTag.last_value === "N/A"
  ) {
    return "";
  }

  return String(liveTag.last_value);
};